import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getJsonStorageTypes, getMyPositions, getReports } from './api';

export const path = '/reports/list';
export const getPath = (id: string, type: string) => `/reports/${!!id ? `${type}/${id}` : `${type}`}`;

const PageTechMapName: React.FC = (props) => {
  const TechMapName = Loadable.Map({
    loader: {
      page: () => import('./page'),
      myPositions: getMyPositions,
      reportsList: getReports,
      jsonStorageTypes: getJsonStorageTypes,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <TechMapName {...props} />;
};

export default PageTechMapName;
